import MenuPopupComponent from "../components/menu-popup-component";
import {renderContact} from "../render-contact";
import {showCatalogPopup} from "../show-catalog-popup";
import {RenderPosition, remove, render} from "../utils/render";


export default class MenuLightController {
  constructor({shopInfoData, logoData, catalogList, onHideModalHanlder}) {
    this._shopInfoData = shopInfoData;
    this._logoData = logoData;
    this._catalogList = catalogList;
    this._onHideModalHanlder = onHideModalHanlder;
    this._authComponent = null;

    this._catalogItemElements = [];

    this._onEscPressModalHandler = this._onEscPressModalHandler.bind(this);
  }

  show() {
    document.querySelector(`body`).classList.add(`overflowHidden`);
    document.addEventListener(`keydown`, this._onEscPressModalHandler);

    this._authComponent = new MenuPopupComponent({
      logoData: this._logoData,
    });
    render(document.querySelector(`body`), this._authComponent.getElement(), RenderPosition.BEFOREEND);

    this._renderContact(this._authComponent.getElement().querySelector(`.contact`));

    // this._authComponent.setCloseButtonClickHandler(() => this._remove());
    this._authComponent.setOverlayClickHandler(() => this._remove());
    this._authComponent.setCatalogButtonClickHandler(() => {
      showCatalogPopup(this._logoData, this._catalogList);
    });
    setTimeout(() => this._authComponent.setShowClass(), 100);
  }

  hide() {
    this._remove();
  }

  _renderContact(container) {
    renderContact(container, this._shopInfoData, this._logoData);
  }

  _remove() {
    this._authComponent.getElement().classList.remove(`popup--show`);
    document.querySelector(`body`).classList.remove(`overflowHidden`);
    document.removeEventListener(`keydown`, this._onEscPressModalHandler);
    this._onHideModalHanlder();
    setTimeout(() => remove(this._authComponent), 1000);
  }

  _onEscPressModalHandler(evt) {
    if (evt.key === `Escape`) {
      this._remove();
    }
  }
}
